import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { S as StepWrapper, a as StepTail, C as Circle, b as CircleBackground, c as ContentWrapper, T as TitleWrapper, d as CircleContent } from './Step.styles-DWLqCWHU.js';
import { S as STATUS } from './constants-uDs2MwW8.js';
import { T as Text } from '../Text/Text-BoJd3LvO.js';

class Step extends PureComponent {
  renderIconNode() {
    const {
      stepNumber,
      status = null,
      icons,
      numbered
    } = this.props;
    let iconNode;
    if (icons && status === STATUS.COMPLETED) {
      iconNode = /*#__PURE__*/React__default.createElement(CircleContent, {
        $status: status,
        $contentType: "icon"
      }, icons.completed);
    } else if (!numbered) {
      iconNode = null;
    } else {
      iconNode = /*#__PURE__*/React__default.createElement(CircleContent, {
        $status: status
      }, stepNumber);
    }
    return iconNode;
  }
  render() {
    const {
      children,
      status = null,
      title = '',
      isVertical = false,
      labelPlacement = 'horizontal',
      statusDescriptions
    } = this.props;
    return /*#__PURE__*/React__default.createElement(StepWrapper, {
      $labelPlacement: labelPlacement,
      $isVertical: isVertical,
      role: "listitem",
      "aria-label": status && statusDescriptions ? statusDescriptions[status] : undefined
    }, /*#__PURE__*/React__default.createElement(StepTail, {
      $labelPlacement: labelPlacement,
      $isVertical: isVertical
    }), /*#__PURE__*/React__default.createElement(Circle, {
      $labelPlacement: labelPlacement,
      $isVertical: isVertical,
      "aria-hidden": "true"
    }, this.renderIconNode(), /*#__PURE__*/React__default.createElement(CircleBackground, {
      $status: status
    })), /*#__PURE__*/React__default.createElement(ContentWrapper, {
      $labelPlacement: labelPlacement,
      $isVertical: isVertical
    }, isVertical && children ? children : /*#__PURE__*/React__default.createElement(Text, {
      type: "span"
    }, /*#__PURE__*/React__default.createElement(TitleWrapper, {
      $status: status
    }, title))));
  }
}
_defineProperty(Step, "propTypes", {
  children: PT.arrayOf(PT.node),
  /**
   * The Step number.
   */
  stepNumber: PT.string,
  /**
   * The icons used in place of the Step.
   */
  icons: PT.objectOf(PT.object),
  /**
   * Denotes if the Step should render vertically.
   */
  isVertical: PT.bool,
  /**
   * Denotes if the Step should be numbered.
   */
  numbered: PT.bool,
  /**
   * Title of the step.
   */
  title: PT.oneOfType([PT.string, PT.node]),
  /**
   * Renders the label either horizontally or vertically.
   */
  labelPlacement: PT.oneOf(['horizontal', 'vertical']),
  /**
   * Set the status of this `<Step>`.If the status is not explicitly set,
   * it will be inferred from the index of the current `<Step>`.
   */
  status: PT.oneOf(['completed', 'active', 'future', 'disabled']),
  /**
   * The aria-label on the Step wrapper div.
   */
  statusDescriptions: PT.objectOf(PT.string)
});
_defineProperty(Step, "defaultProps", {
  children: [],
  icons: {},
  isVertical: false,
  numbered: true,
  title: '',
  labelPlacement: 'horizontal',
  status: null,
  stepNumber: null,
  statusDescriptions: {}
});

export { Step as S };
//# sourceMappingURL=Step-Bk_5_1jj.js.map
